((Global, $) => {
  'use strict';

  // FADE IN SCROLL
  // Test two
  const fadeScroll = () => {
    var scrollDistance;
    $(window).scroll(onScrollHandler);

    function onScrollHandler() {
      var $fadeItem = $('.fade-item');
      scrollDistance = $(document).scrollTop();
      $fadeItem.each(function () {
        if (isScrolledIntoView(this) === true) {
          $(this).addClass('enter-viewport');
        }
      });
    }

    function isScrolledIntoView(elem) {
      // distance of top of page, to bottom of screen.
      var docViewBottom = scrollDistance + $(window).height();

      // position of the element
      var elemTop = $(elem).offset().top;

      // elements are offset by 90px, but we want to scroll them into view
      // once they are 200px into view
      return docViewBottom >= (elemTop - 90 + 250);
    }

    // limit how often a function gets triggered
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    }
  }; // End _fadeScroll()

  // Event Bindings
  const bindUIActions = () => {
    $('.mobile-nav-items a.no-padding').click(function () {
      var linkURL = $(this).attr('href');
      window.location.href = linkURL;
      return false;
    });

    // Toggle Sweet Tooth Modal
    $('[href="#vip-rewards"]').on('click', function (e) {
      e.preventDefault();
      SweetTooth.publish('st-intent', 'st:core:home');
    });

    $('.more-dropdown-box').delegate('[href="#vip-rewards"]', 'click', function (e) {
      e.preventDefault();
      SweetTooth.publish('st-intent', 'st:core:home');
    });

    // Email Form Validation From Popup
    $('#mc_embed_signup').find('form').ajaxChimp();

    // Interstitial Cookie + Popup
    setTimeout(function () {
      var modalDisplayedCookie = Boolean(window.Cookies.get('modal_displayed'));
      var interstitialValue = '{{settings.interstitial}}';

      if (!modalDisplayedCookie) {

        window.Cookies.set('modal_displayed', true, { expires: 1 });

        if (interstitialValue === 'promo') {
          fleshlight.methods.modals._open('', 'free-shipping');
        } else if (interstitialValue === 'email') {
          fleshlight.methods.modals._open('', 'percent-off');
        } else {
          return;
        }
      }
    }, 3000);
  };

  // Public
  const init = () => {
    fadeScroll();
    bindUIActions();
  };

  Global.init = init;

})(window.Global = window.Global || {}, jQuery);
